var _path, _path2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6373_1125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33332 11.3333C5.34441 11.3333 4.37771 11.0401 3.55546 10.4907C2.73322 9.94126 2.09236 9.16036 1.71392 8.24673C1.33548 7.3331 1.23646 6.32777 1.42939 5.35786C1.62232 4.38796 2.09852 3.49704 2.79778 2.79778C3.49704 2.09852 4.38796 1.62231 5.35786 1.42939C6.32777 1.23646 7.3331 1.33548 8.24673 1.71392C9.16036 2.09236 9.94126 2.73322 10.4907 3.55546C11.0401 4.37771 11.3333 5.34441 11.3333 6.33332C11.3333 7.6594 10.8065 8.93117 9.86885 9.86885C8.93117 10.8065 7.6594 11.3333 6.33332 11.3333ZM6.33332 2.66665C5.60812 2.66665 4.89921 2.88169 4.29622 3.28459C3.69324 3.68749 3.22328 4.26015 2.94576 4.93014C2.66824 5.60014 2.59562 6.33738 2.7371 7.04865C2.87858 7.75991 3.2278 8.41325 3.74059 8.92604C4.25338 9.43883 4.90672 9.78805 5.61798 9.92953C6.32925 10.071 7.06649 9.99839 7.73649 9.72087C8.40649 9.44335 8.97914 8.97339 9.38204 8.37041C9.78494 7.76743 9.99998 7.05851 9.99998 6.33332C9.99822 5.3614 9.61135 4.42979 8.92409 3.74254C8.23684 3.05529 7.30524 2.66841 6.33332 2.66665Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88019 10.4858L10.823 9.54297L13.6514 12.3714C13.7764 12.4964 13.8467 12.666 13.8467 12.8428C13.8467 13.0196 13.7764 13.1892 13.6514 13.3142C13.5264 13.4392 13.3568 13.5095 13.18 13.5095C13.0032 13.5095 12.8336 13.4392 12.7086 13.3142L9.88019 10.4858Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6373_1125)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#35658D"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.950ed4e00bd645b09c68d3b60ebd6957.svg";
export { ForwardRef as ReactComponent };